export default __webpack_public_path__ + "static/media/toast-check.0cdcc162.svg";